import React from "react";
import StatutoryAndCompliancebanner from "../../AVHRBanner/Statutory_and_Compliance_Banner.png";
import "../OurServicesCss/Services.css";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";

function StatutoryAndCompliance() {
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  return (
    <>
      <div style={{ paddingTop: "100px" }}>
        <div className="relative w-full h-[400px] sm:h-[500px] md:h-[600px] lg:h-[700px] xl:h-[800px] banner">
          <img
            src={StatutoryAndCompliancebanner}
            className="absolute inset-0 w-full h-full object-cover"
            alt=""
          />

          {/* Centered Content */}
          <div className="relative z-10 flex items-center justify-center h-full px-4 text-adjest">
            <div className="text-bannar max-w-3xl text-left avhrProject-bannerTextColour">
              <p className="edu-support-text uppercase"> Our Services</p>

              <h1 className="career-library-heading">
                Statutory And Compliance
              </h1>
            </div>
          </div>
        </div>

        <div className="text-center px-4 md:px-8 mt-6">
          <h1 className="mb-2 avhrProject-h1">
            Statutory and Compliance Services and Benefits
          </h1>
        </div>

        <div className="grid justify-content-center align-items-stretch mt-4 gap-4 px-3 md:px-4">
          <div className="col-12 md:col-5 lg:col-5 p-3 ">
            <div
              className="shadow-4 p-4 h-full  card-hover-effect"
              style={{ borderRadius: "10px", backgroundColor: "#f2c176" }}
            >
              <h2
                className="mb-4 avhrProject-h2"
                style={{ textAlign: "center" }}
              >
                Services
              </h2>

              <div className="avhrProject-p mb-4">
                <ul style={{ listStyleType: "none", paddingLeft: "0" }}>
                  <li className="mb-3">📋 Payroll Compliance</li>
                  <li className="mb-3">💰 Handling Payroll Taxation</li>
                  <li className="mb-3">🔍 Process Review and Gap Analysis</li>
                  <li className="mb-3">📝 Labor Law Compliance</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="col-12 md:col-5 lg:col-5 p-3">
            <div
              className="shadow-4 p-4 h-full card-hover-effect"
              style={{ borderRadius: "10px", backgroundColor: "#dcce8a" }}
            >
              <h2
                className="mb-2 avhrProject-h2"
                style={{ textAlign: "center" }}
              >
                Benefits
              </h2>

              <div className="avhrProject-p mb-4">
                <ul style={{ listStyleType: "none", paddingLeft: "0" }}>
                  <li className="mb-3">
                    🛡️ <b>Reduced Risks:</b> We help you avoid legal troubles,
                    fines, and lawsuits that can arise from not following the
                    rules
                  </li>
                  <li className="mb-3">
                    ⏱️ <b>Time Saved:</b> Focus on your core business activities
                    while we handle all compliance tasks
                  </li>
                  <li className="mb-3">
                    😌 <b>Worry-Free:</b> Stay updated on changes in laws and
                    special requirements for your industry, so you don’t have to
                    worry about them
                  </li>
                  <li className="mb-3">
                    ⚙️ <b>Efficient Operations:</b>
                    We streamline your HR processes by ensuring proper
                    procedures are followed and paperwork is always in order
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="w-full px-4 py-4 sm:px-6 md:px-10 lg:px-16">
          <Card
            className="CARDCOLOUR m-3"
            style={{
              background: "linear-gradient(-120deg, #FFE0A8, #F59B8A, #F08FA8)",
            }}
          >
            <p className="mb-2 text-center avhrProject-p">Get Started</p>
            <h2 className="mt-2 text-center avhrProject-h2 ">
              End-to-end compliance to stay up-to-date
            </h2>

            <div className="flex justify-content-center">
              <Button
                label="Contact Us"
                rounded
                onClick={() => handleNavigate("/contactus")}
                className="buttonAvhrProject"
              />
            </div>
          </Card>
        </div>
      </div>
    </>
  );
}

export default StatutoryAndCompliance;
